/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 映像フレームを 0〜1 とした矩形（コンテナ基準ではない・ADR-0022）
 */
export interface HotspotRect {
  h: number
  w: number
  y: number
  x: number
}
